<div class="row">
  <div class="col-md-6">

    <div class="form-group row">
      <label for="title" class="col-sm-4 col-form-label">Title</label>
      <div class="col-sm-8">
        <select id="title" class="form-control form-control-sm" [(ngModel)]="formData.title">
          <option>Select..</option>
          <option>Mr</option>
          <option>Mrs</option>
          <option>Mr &amp; Mrs</option>
          <option>Ms</option>
          <option>Miss</option>
          <option>Dr</option>
          <option>Rev</option>
          <option>Dame</option>
          <option>Lady</option>
          <option>Sir</option>
          <option>Lord</option>
        </select>
      </div>
    </div>

    <div class="form-group row">
      <label for="firstName" class="col-sm-4 col-form-label">First Name<sup class="text-danger">*</sup></label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="firstName" placeholder="First Name" [(ngModel)]="formData.firstName"
          required>
      </div>
    </div>

    <div class="form-group row">
      <label for="lastName" class="col-sm-4 col-form-label">Last Name<sup class="text-danger">*</sup></label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="lastName" placeholder="Last Name" [(ngModel)]="formData.lastName"
          required>
      </div>
    </div>

    <div class="form-group row">
      <label for="homeNumber" class="col-sm-4 col-form-label">
        Home Number<sup class="text-danger" *ngIf="!formData.mobileNumber">*</sup>
      </label>
      <div class="col-sm-8">
        <input id="homeNumber" type="text" name="homeNumber" #homeNumber="ngModel" class="form-control form-control-sm" placeholder="Home Number"
          [(ngModel)]="formData.homeNumber" [required]="!formData.mobileNumber" validPhoneNumber>
        <small *ngIf="!validPhoneNumber(formData.homeNumber, 'landline')" class="form-text text-danger">
          Valid home number is required without the country code 44
        </small>
      </div>
    </div>

    <div class="form-group row">
      <label for="mobileNumber" class="col-sm-4 col-form-label">
        Mobile Number<sup class="text-danger" *ngIf="!formData.homeNumber">*</sup>
      </label>
      <div class="col-sm-8">
        <input id="mobileNumber" type="text" name="mobileNumber" #mobileNumber="ngModel" class="form-control form-control-sm" placeholder="Mobile Number"
          [(ngModel)]="formData.mobileNumber" [required]="!formData.homeNumber">
        <small *ngIf="!validPhoneNumber(formData.mobileNumber, 'mobile')" class="form-text text-danger">Valid mobile number is required without the country code 44</small>
      </div>
    </div>

    <div class="form-group row">
      <label for="emailAddress" class="col-sm-4 col-form-label">E-Mail Address</label>
      <div class="col-sm-8">
        <input type="email" class="form-control form-control-sm" id="emailAddress" placeholder="E-Mail Address" [(ngModel)]="formData.email">
      </div>
    </div>

  </div>
  <div class="col-md-6">

    <div class="form-group row">
      <label for="address1" class="col-sm-4 col-form-label">Address 1<sup class="text-danger">*</sup></label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="address1" placeholder="Address 1" [(ngModel)]="formData.address1"
          required>
      </div>
    </div>

    <div class="form-group row">
      <label for="address2" class="col-sm-4 col-form-label">Address 2</label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="address2" placeholder="Address 2" [(ngModel)]="formData.address2">
      </div>
    </div>

    <div class="form-group row">
      <label for="address3" class="col-sm-4 col-form-label">Address 3</label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="address3" placeholder="Address 3" [(ngModel)]="formData.address3">
      </div>
    </div>

    <div class="form-group row">
      <label for="town" class="col-sm-4 col-form-label">Town</label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="town" placeholder="Town" [(ngModel)]="formData.town">
      </div>
    </div>

    <div class="form-group row">
      <label for="postalCode" class="col-sm-4 col-form-label">Postcode<sup class="text-danger">*</sup></label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="postalCode" placeholder="Postcode" [(ngModel)]="formData.postalCode"
               required validPostcode #postcode="ngModel">
        <small *ngIf="postcode.invalid && postcode.value" class="form-text text-danger">Please provide a valid postcode.</small>
      </div>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/contact-details/app-contact-details.component.html